module.exports = __webpack_public_path__ + "img/graph.cbf4139a.svg";